import { TABLET_SCREEN_WIDTH } from 'constants/general';

export const isMobileDevice = (): boolean => (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
    .test(navigator.userAgent)
);

export const isEqualOrMoreThanTablet = (): boolean => window.innerWidth >= TABLET_SCREEN_WIDTH;

export const isWindowWidthLessXLSize = (innerWidth: number) => innerWidth <= 1499;